import React from "react";
import "circular-std";
import { css, Global } from "@emotion/core";

import { baseFont, colors } from "./utils";

const { black } = colors;

const font = css`
  html {
    -webkit-font-smoothing: antialiased;
    font-family: ${baseFont};
    color: ${black};
    box-sizing: border-box;
  }

  *,
  *:before,
  *:after {
    box-sizing: inherit;
  }
`;

const links = css`
  a,
  a:active,
  a:hover,
  a:focus {
    color: inherit;
    text-decoration: none;
  }
`;

export default () => (
  <>
    <Global
      styles={css`
        ${font};
        ${links};
      `}
    />
  </>
);
